export default "__VITE_PUBLIC_ASSET__a477cfbf__"